import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import * as Sentry from '@sentry/react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';

const parseSampleRate = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }
  return Math.min(Math.max(parsed, 0), 1);
};

const sentryTracesSampleRate = parseSampleRate(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  0.05
);

Sentry.init({
  dsn: 'https://70e4e884b1a54f7d8948a538f9c494ac@o1141627.ingest.sentry.io/4504733743775744',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  enabled: `${process.env.NODE_ENV}` !== 'development',
  tracesSampleRate: sentryTracesSampleRate,
  release: `${import.meta.env.VITE_REPOSITORY}@${import.meta.env.VITE_IMAGE_TAG}`,
});
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
